import script from "./personalDeskTop.vue?vue&type=script&setup=true&lang=js"
export * from "./personalDeskTop.vue?vue&type=script&setup=true&lang=js"

import "./personalDeskTop.vue?vue&type=style&index=0&id=1211c626&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1211c626"]])

export default __exports__